import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { UserRole } from "../../../@types/userRole";
import api from "../../../utils/api";
import axiosInstance from "../../../utils/axiosConfig";

export const findSingleUserRole = createAsyncThunk(
  "massiveDocumentCreate/findSingleUserRole",
  async (id : any, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get(`${api.baseURL}userrole?user=${id}&enabled=true`);

      return data as UserRole[];
    } catch (error:any) {
      const {message} = error
      rejectWithValue(message);
      throw message;
    }
  }
);
